export const DEFAULT_THEME_ID = 'ocean-light';

/** @type {Array<{id:string,name:string,group:string,mode:'light'|'dark',preview:{primary:string,surface:string,accent:string},vars:Record<string,string>}>} */
export const themes = [
  // ─── Ocean Blue (default) ────────────────────────────────────────────────
  {
    id: 'ocean-light',
    name: 'Ocean Blue',
    group: 'ocean',
    mode: 'light',
    preview: { primary: '#2563eb', surface: '#eff6ff', accent: '#60a5fa' },
    vars: {
      '--color-brand-50':  '#eff6ff',
      '--color-brand-100': '#dbeafe',
      '--color-brand-200': '#bfdbfe',
      '--color-brand-300': '#93c5fd',
      '--color-brand-400': '#60a5fa',
      '--color-brand-500': '#3b82f6',
      '--color-brand-600': '#2563eb',
      '--color-brand-700': '#1d4ed8',
      '--color-brand-800': '#1e40af',
      '--color-brand-900': '#1e3a8a',
    },
  },
  {
    id: 'ocean-dark',
    name: 'Ocean Blue',
    group: 'ocean',
    mode: 'dark',
    preview: { primary: '#60a5fa', surface: '#1e3a8a', accent: '#93c5fd' },
    vars: {
      '--color-brand-50':  '#eff6ff',
      '--color-brand-100': '#dbeafe',
      '--color-brand-200': '#bfdbfe',
      '--color-brand-300': '#93c5fd',
      '--color-brand-400': '#60a5fa',
      '--color-brand-500': '#3b82f6',
      '--color-brand-600': '#2563eb',
      '--color-brand-700': '#1d4ed8',
      '--color-brand-800': '#1e40af',
      '--color-brand-900': '#1e3a8a',
    },
  },

  // ─── Emerald ─────────────────────────────────────────────────────────────
  {
    id: 'emerald-light',
    name: 'Emerald',
    group: 'emerald',
    mode: 'light',
    preview: { primary: '#059669', surface: '#ecfdf5', accent: '#34d399' },
    vars: {
      '--color-brand-50':  '#ecfdf5',
      '--color-brand-100': '#d1fae5',
      '--color-brand-200': '#a7f3d0',
      '--color-brand-300': '#6ee7b7',
      '--color-brand-400': '#34d399',
      '--color-brand-500': '#10b981',
      '--color-brand-600': '#059669',
      '--color-brand-700': '#047857',
      '--color-brand-800': '#065f46',
      '--color-brand-900': '#064e3b',
    },
  },
  {
    id: 'emerald-dark',
    name: 'Emerald',
    group: 'emerald',
    mode: 'dark',
    preview: { primary: '#34d399', surface: '#064e3b', accent: '#6ee7b7' },
    vars: {
      '--color-brand-50':  '#ecfdf5',
      '--color-brand-100': '#d1fae5',
      '--color-brand-200': '#a7f3d0',
      '--color-brand-300': '#6ee7b7',
      '--color-brand-400': '#34d399',
      '--color-brand-500': '#10b981',
      '--color-brand-600': '#059669',
      '--color-brand-700': '#047857',
      '--color-brand-800': '#065f46',
      '--color-brand-900': '#064e3b',
    },
  },

  // ─── Royal Indigo ────────────────────────────────────────────────────────
  {
    id: 'indigo-light',
    name: 'Royal Indigo',
    group: 'indigo',
    mode: 'light',
    preview: { primary: '#4f46e5', surface: '#eef2ff', accent: '#818cf8' },
    vars: {
      '--color-brand-50':  '#eef2ff',
      '--color-brand-100': '#e0e7ff',
      '--color-brand-200': '#c7d2fe',
      '--color-brand-300': '#a5b4fc',
      '--color-brand-400': '#818cf8',
      '--color-brand-500': '#6366f1',
      '--color-brand-600': '#4f46e5',
      '--color-brand-700': '#4338ca',
      '--color-brand-800': '#3730a3',
      '--color-brand-900': '#312e81',
    },
  },
  {
    id: 'indigo-dark',
    name: 'Royal Indigo',
    group: 'indigo',
    mode: 'dark',
    preview: { primary: '#818cf8', surface: '#312e81', accent: '#a5b4fc' },
    vars: {
      '--color-brand-50':  '#eef2ff',
      '--color-brand-100': '#e0e7ff',
      '--color-brand-200': '#c7d2fe',
      '--color-brand-300': '#a5b4fc',
      '--color-brand-400': '#818cf8',
      '--color-brand-500': '#6366f1',
      '--color-brand-600': '#4f46e5',
      '--color-brand-700': '#4338ca',
      '--color-brand-800': '#3730a3',
      '--color-brand-900': '#312e81',
    },
  },

  // ─── Sunset Orange ───────────────────────────────────────────────────────
  {
    id: 'sunset-light',
    name: 'Sunset Orange',
    group: 'sunset',
    mode: 'light',
    preview: { primary: '#ea580c', surface: '#fff7ed', accent: '#fb923c' },
    vars: {
      '--color-brand-50':  '#fff7ed',
      '--color-brand-100': '#ffedd5',
      '--color-brand-200': '#fed7aa',
      '--color-brand-300': '#fdba74',
      '--color-brand-400': '#fb923c',
      '--color-brand-500': '#f97316',
      '--color-brand-600': '#ea580c',
      '--color-brand-700': '#c2410c',
      '--color-brand-800': '#9a3412',
      '--color-brand-900': '#7c2d12',
    },
  },
  {
    id: 'sunset-dark',
    name: 'Sunset Orange',
    group: 'sunset',
    mode: 'dark',
    preview: { primary: '#fb923c', surface: '#7c2d12', accent: '#fdba74' },
    vars: {
      '--color-brand-50':  '#fff7ed',
      '--color-brand-100': '#ffedd5',
      '--color-brand-200': '#fed7aa',
      '--color-brand-300': '#fdba74',
      '--color-brand-400': '#fb923c',
      '--color-brand-500': '#f97316',
      '--color-brand-600': '#ea580c',
      '--color-brand-700': '#c2410c',
      '--color-brand-800': '#9a3412',
      '--color-brand-900': '#7c2d12',
    },
  },

  // ─── Crimson ─────────────────────────────────────────────────────────────
  {
    id: 'crimson-light',
    name: 'Crimson',
    group: 'crimson',
    mode: 'light',
    preview: { primary: '#dc2626', surface: '#fef2f2', accent: '#f87171' },
    vars: {
      '--color-brand-50':  '#fef2f2',
      '--color-brand-100': '#fee2e2',
      '--color-brand-200': '#fecaca',
      '--color-brand-300': '#fca5a5',
      '--color-brand-400': '#f87171',
      '--color-brand-500': '#ef4444',
      '--color-brand-600': '#dc2626',
      '--color-brand-700': '#b91c1c',
      '--color-brand-800': '#991b1b',
      '--color-brand-900': '#7f1d1d',
    },
  },
  {
    id: 'crimson-dark',
    name: 'Crimson',
    group: 'crimson',
    mode: 'dark',
    preview: { primary: '#f87171', surface: '#7f1d1d', accent: '#fca5a5' },
    vars: {
      '--color-brand-50':  '#fef2f2',
      '--color-brand-100': '#fee2e2',
      '--color-brand-200': '#fecaca',
      '--color-brand-300': '#fca5a5',
      '--color-brand-400': '#f87171',
      '--color-brand-500': '#ef4444',
      '--color-brand-600': '#dc2626',
      '--color-brand-700': '#b91c1c',
      '--color-brand-800': '#991b1b',
      '--color-brand-900': '#7f1d1d',
    },
  },

  // ─── Graphite ────────────────────────────────────────────────────────────
  {
    id: 'graphite-light',
    name: 'Graphite',
    group: 'graphite',
    mode: 'light',
    preview: { primary: '#475569', surface: '#f8fafc', accent: '#94a3b8' },
    vars: {
      '--color-brand-50':  '#f8fafc',
      '--color-brand-100': '#f1f5f9',
      '--color-brand-200': '#e2e8f0',
      '--color-brand-300': '#cbd5e1',
      '--color-brand-400': '#94a3b8',
      '--color-brand-500': '#64748b',
      '--color-brand-600': '#475569',
      '--color-brand-700': '#334155',
      '--color-brand-800': '#1e293b',
      '--color-brand-900': '#0f172a',
    },
  },
  {
    id: 'graphite-dark',
    name: 'Graphite',
    group: 'graphite',
    mode: 'dark',
    preview: { primary: '#94a3b8', surface: '#0f172a', accent: '#cbd5e1' },
    vars: {
      '--color-brand-50':  '#f8fafc',
      '--color-brand-100': '#f1f5f9',
      '--color-brand-200': '#e2e8f0',
      '--color-brand-300': '#cbd5e1',
      '--color-brand-400': '#94a3b8',
      '--color-brand-500': '#64748b',
      '--color-brand-600': '#475569',
      '--color-brand-700': '#334155',
      '--color-brand-800': '#1e293b',
      '--color-brand-900': '#0f172a',
    },
  },

  // ─── Teal ─────────────────────────────────────────────────────────────────
  {
    id: 'teal-light',
    name: 'Teal',
    group: 'teal',
    mode: 'light',
    preview: { primary: '#0d9488', surface: '#f0fdfa', accent: '#2dd4bf' },
    vars: {
      '--color-brand-50':  '#f0fdfa',
      '--color-brand-100': '#ccfbf1',
      '--color-brand-200': '#99f6e4',
      '--color-brand-300': '#5eead4',
      '--color-brand-400': '#2dd4bf',
      '--color-brand-500': '#14b8a6',
      '--color-brand-600': '#0d9488',
      '--color-brand-700': '#0f766e',
      '--color-brand-800': '#115e59',
      '--color-brand-900': '#134e4a',
    },
  },
  {
    id: 'teal-dark',
    name: 'Teal',
    group: 'teal',
    mode: 'dark',
    preview: { primary: '#2dd4bf', surface: '#134e4a', accent: '#5eead4' },
    vars: {
      '--color-brand-50':  '#f0fdfa',
      '--color-brand-100': '#ccfbf1',
      '--color-brand-200': '#99f6e4',
      '--color-brand-300': '#5eead4',
      '--color-brand-400': '#2dd4bf',
      '--color-brand-500': '#14b8a6',
      '--color-brand-600': '#0d9488',
      '--color-brand-700': '#0f766e',
      '--color-brand-800': '#115e59',
      '--color-brand-900': '#134e4a',
    },
  },

  // ─── Violet ───────────────────────────────────────────────────────────────
  {
    id: 'violet-light',
    name: 'Violet',
    group: 'violet',
    mode: 'light',
    preview: { primary: '#7c3aed', surface: '#f5f3ff', accent: '#a78bfa' },
    vars: {
      '--color-brand-50':  '#f5f3ff',
      '--color-brand-100': '#ede9fe',
      '--color-brand-200': '#ddd6fe',
      '--color-brand-300': '#c4b5fd',
      '--color-brand-400': '#a78bfa',
      '--color-brand-500': '#8b5cf6',
      '--color-brand-600': '#7c3aed',
      '--color-brand-700': '#6d28d9',
      '--color-brand-800': '#5b21b6',
      '--color-brand-900': '#4c1d95',
    },
  },
  {
    id: 'violet-dark',
    name: 'Violet',
    group: 'violet',
    mode: 'dark',
    preview: { primary: '#a78bfa', surface: '#4c1d95', accent: '#c4b5fd' },
    vars: {
      '--color-brand-50':  '#f5f3ff',
      '--color-brand-100': '#ede9fe',
      '--color-brand-200': '#ddd6fe',
      '--color-brand-300': '#c4b5fd',
      '--color-brand-400': '#a78bfa',
      '--color-brand-500': '#8b5cf6',
      '--color-brand-600': '#7c3aed',
      '--color-brand-700': '#6d28d9',
      '--color-brand-800': '#5b21b6',
      '--color-brand-900': '#4c1d95',
    },
  },

  // ─── Rose ─────────────────────────────────────────────────────────────────
  {
    id: 'rose-light',
    name: 'Rose',
    group: 'rose',
    mode: 'light',
    preview: { primary: '#e11d48', surface: '#fff1f2', accent: '#fb7185' },
    vars: {
      '--color-brand-50':  '#fff1f2',
      '--color-brand-100': '#ffe4e6',
      '--color-brand-200': '#fecdd3',
      '--color-brand-300': '#fda4af',
      '--color-brand-400': '#fb7185',
      '--color-brand-500': '#f43f5e',
      '--color-brand-600': '#e11d48',
      '--color-brand-700': '#be123c',
      '--color-brand-800': '#9f1239',
      '--color-brand-900': '#881337',
    },
  },
  {
    id: 'rose-dark',
    name: 'Rose',
    group: 'rose',
    mode: 'dark',
    preview: { primary: '#fb7185', surface: '#881337', accent: '#fda4af' },
    vars: {
      '--color-brand-50':  '#fff1f2',
      '--color-brand-100': '#ffe4e6',
      '--color-brand-200': '#fecdd3',
      '--color-brand-300': '#fda4af',
      '--color-brand-400': '#fb7185',
      '--color-brand-500': '#f43f5e',
      '--color-brand-600': '#e11d48',
      '--color-brand-700': '#be123c',
      '--color-brand-800': '#9f1239',
      '--color-brand-900': '#881337',
    },
  },

  // ─── Amber Gold ───────────────────────────────────────────────────────────
  {
    id: 'amber-light',
    name: 'Amber Gold',
    group: 'amber',
    mode: 'light',
    preview: { primary: '#d97706', surface: '#fffbeb', accent: '#fbbf24' },
    vars: {
      '--color-brand-50':  '#fffbeb',
      '--color-brand-100': '#fef3c7',
      '--color-brand-200': '#fde68a',
      '--color-brand-300': '#fcd34d',
      '--color-brand-400': '#fbbf24',
      '--color-brand-500': '#f59e0b',
      '--color-brand-600': '#d97706',
      '--color-brand-700': '#b45309',
      '--color-brand-800': '#92400e',
      '--color-brand-900': '#78350f',
    },
  },
  {
    id: 'amber-dark',
    name: 'Amber Gold',
    group: 'amber',
    mode: 'dark',
    preview: { primary: '#fbbf24', surface: '#78350f', accent: '#fcd34d' },
    vars: {
      '--color-brand-50':  '#fffbeb',
      '--color-brand-100': '#fef3c7',
      '--color-brand-200': '#fde68a',
      '--color-brand-300': '#fcd34d',
      '--color-brand-400': '#fbbf24',
      '--color-brand-500': '#f59e0b',
      '--color-brand-600': '#d97706',
      '--color-brand-700': '#b45309',
      '--color-brand-800': '#92400e',
      '--color-brand-900': '#78350f',
    },
  },

  // ─── Designer Presets ─────────────────────────────────────────────────────

  // Midnight — deep navy dark (Linear-inspired)
  {
    id: 'midnight',
    name: 'Midnight',
    group: 'midnight',
    mode: 'dark',
    preview: { primary: '#6490f5', surface: '#0d1117', accent: '#93b4fb' },
    vars: {
      '--color-brand-50':  '#eef3fe',
      '--color-brand-100': '#d9e5fd',
      '--color-brand-200': '#bcccfb',
      '--color-brand-300': '#93b4fb',
      '--color-brand-400': '#6490f5',
      '--color-brand-500': '#4570ec',
      '--color-brand-600': '#3155d6',
      '--color-brand-700': '#2641ac',
      '--color-brand-800': '#1a2d7a',
      '--color-brand-900': '#0d1a4a',
    },
  },

  // Nordic — cool muted dark (Nord palette inspired)
  {
    id: 'nordic',
    name: 'Nordic',
    group: 'nordic',
    mode: 'dark',
    preview: { primary: '#88c0d0', surface: '#2e3440', accent: '#81a1c1' },
    vars: {
      '--color-brand-50':  '#ecf4f7',
      '--color-brand-100': '#d8e9ef',
      '--color-brand-200': '#b5d3df',
      '--color-brand-300': '#88c0d0',
      '--color-brand-400': '#81a1c1',
      '--color-brand-500': '#5e81ac',
      '--color-brand-600': '#4c6f9a',
      '--color-brand-700': '#3b5c88',
      '--color-brand-800': '#2e3f5c',
      '--color-brand-900': '#2e3440',
    },
  },

  // Solar Light — warm cream light (Solarized-inspired)
  {
    id: 'solar-light',
    name: 'Solar',
    group: 'solar',
    mode: 'light',
    preview: { primary: '#b58900', surface: '#fdf6e3', accent: '#cb4b16' },
    vars: {
      '--color-brand-50':  '#fdf6e3',
      '--color-brand-100': '#fbf0cb',
      '--color-brand-200': '#f7e29b',
      '--color-brand-300': '#f0c755',
      '--color-brand-400': '#e6a817',
      '--color-brand-500': '#cb9000',
      '--color-brand-600': '#b58900',
      '--color-brand-700': '#967200',
      '--color-brand-800': '#6e5200',
      '--color-brand-900': '#4a3700',
    },
  },

  // Slate Pro — neutral slate light (GitHub-inspired professional)
  {
    id: 'slate-pro',
    name: 'Slate Pro',
    group: 'slate-pro',
    mode: 'light',
    preview: { primary: '#0969da', surface: '#f6f8fa', accent: '#0550ae' },
    vars: {
      '--color-brand-50':  '#ddf4ff',
      '--color-brand-100': '#b6e3ff',
      '--color-brand-200': '#80ccff',
      '--color-brand-300': '#54aeff',
      '--color-brand-400': '#218bff',
      '--color-brand-500': '#0969da',
      '--color-brand-600': '#0550ae',
      '--color-brand-700': '#033d8b',
      '--color-brand-800': '#0a3069',
      '--color-brand-900': '#002155',
    },
  },
];

/**
 * Look up a theme descriptor by ID. Returns the default theme if not found.
 * @param {string} id
 */
export function getTheme(id) {
  return themes.find((t) => t.id === id) ?? themes.find((t) => t.id === DEFAULT_THEME_ID);
}
